import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { BaseComponent } from "BaseComponent";
import Pagination from "react-js-pagination";
import {
  fetchEmailLog,
  searchEmailLogs,
  sortEmailLogByStatus,
  fetchAllEmailLog,
} from "SettingActions";
import { itemCount, screenHeightLeftFromTop, isTablet } from "Constants";
import NoContent, { NO_EMAILLOGS } from "NoContent";
import ListItem from "EmailLogListItem";
import Loader from "Loader";
import LocaleStrings from "Languages";

class EmailLog extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      pageNumber: 1,
      executed: false,
      desc: LocaleStrings.loaderDesc_EmailLog,
      loading: true,
      sortByCategory: "all",
    };

    this.sortByUserCategory = this.sortByUserCategory.bind(this);
    // this.paginationCallback = this.paginationCallback.bind(this);
  }

  componentDidMount() {
    this.props.fetchAllEmailLog(this.props.session);
    this.props.fetchEmailLog(this.props.session, 0, (callback) => {
      this.setState({ loading: false });
    });
  }

  paginationCallback = (pageNumber) => {
    let { search, sortByCategory } = this.state;

    if (search === "" && sortByCategory == "all") {
      this.props.fetchEmailLog(this.props.session, pageNumber);
    } else if (search === "" && sortByCategory != "all") {
      this.props.sortEmailLogByStatus(
        this.props.session,
        sortByCategory,
        pageNumber,
        0,
        (response) => {}
      );
    } else {
      this.props.searchEmailLogs(this.props.session, search, pageNumber);
    }

    this.setState({ ...this.state, pageNumber });
  };

  handleSearch = (event) => {
    var search = event.target.value;
    var pageNumber = 1;

    if (search === "") {
      this.props.fetchEmailLog(this.props.session, 0, (callback) => {});
    } else {
      this.props.searchEmailLogs(this.props.session, search, 0);
    }

    this.setState({ search, pageNumber });
  };

  renderList() {
    let { pageNumber, emailLogData } = this.props;
    let pageDataLength =
      emailLogData.data && emailLogData.data.length > 0
        ? emailLogData.data.length
        : 1;

    var items = _.map(emailLogData.data, (logdata) => (
      <ListItem
        key={logdata.logid}
        logdata={logdata}
        pagination={this.paginationCallback}
        pageDataLength={pageDataLength}
        currentPage={pageNumber}
      />
    ));
    return items;
  }

  sortByUserCategory = (e, sel) => {
    // e.preventDefault();
    var sortByCategory = sel == "select" ? e.target.value : e;

    let pageNumber = 1;
    if (sortByCategory === "all") {
      this.props.fetchEmailLog(
        this.props.session,
        pageNumber,
        (response) => {}
      );
    } else {
      this.props.sortEmailLogByStatus(
        this.props.session,
        sortByCategory,
        pageNumber,
        0,
        (response) => {}
      );
    }
    this.setState({ sortByCategory, pageNumber });
  };

  render() {
    let { deviceSize, emailLogData, allEmailLog } = this.props;
    let { search, pageNumber, sortByCategory } = this.state;
    var categories = [
      { label: LocaleStrings.filter_by_all, value: "all" },
      { label: LocaleStrings.delivered, value: "delivered" },
      { label: LocaleStrings.opened, value: "opened" },
      { label: LocaleStrings.failed, value: "failed" },
    ];

    const mapObj = {
      startnum: pageNumber === 1 ? 1 : itemCount * (pageNumber - 1) + 1,
      endnum:
        emailLogData.count > itemCount * pageNumber
          ? itemCount * pageNumber
          : emailLogData.count,
      totalnum: emailLogData.count,
    };
    let opened = [];
    let delivered = [];
    let failed = [];

    if (allEmailLog && allEmailLog.data && allEmailLog.data.length > 0) {
      opened = _.filter(allEmailLog.data, function (o) {
        return o.email_status == "opened";
      });
      delivered = _.filter(allEmailLog.data, function (o) {
        return o.email_status == "delivered";
      });
      failed = _.filter(allEmailLog.data, function (o) {
        return o.email_status == "failed";
      });
    }
    var opencursorStyle = "pointer";
    var failedcursorStyle = "pointer";
    var deliveredcursorStyle = "pointer";
    var openSelected = "";
    var failedSelected = "";
    var deliveredSelected = "";

    if (sortByCategory == "opened") {
      opencursorStyle = "default";
      openSelected = "active";
    }
    if (sortByCategory == "failed") {
      failedcursorStyle = "default";
      failedSelected = "active";
    }
    if (sortByCategory == "delivered") {
      deliveredcursorStyle = "default";
      deliveredSelected = "active";
    }

    return (
      <div className="panel noborder-panel">
        <div className="content-header-bar">
          <div className="vertical-align-center">
            <div className="custom-text3-primary-medium">
              {LocaleStrings.headertext_EmailLog}
            </div>
          </div>

          <ul className="header-buttons">
            <li>
              <input
                className="form-control mapsearch"
                placeholder="Search With Email"
                type="text"
                value={search}
                onChange={this.handleSearch}
                style={{ width: 300 }}
              />
            </li>
          </ul>
        </div>

        <div className="clearfix" />

        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <>
              <div>
                <ul className="nav nav-pills dashboardNavPill">
                  <li
                    className={"emaillog-box " + deliveredSelected}
                    onClick={() => this.sortByUserCategory("delivered", "li")}
                    style={{
                      cursor: `${deliveredcursorStyle}`,
                    }}
                  >
                    <div>
                      <span className="pull-right iconCircularRight">
                        <div className=""></div>
                      </span>
                      <span className="pull-left txtLeft txtLeftSupport">
                        <p className="bigNumbers">{delivered.length}</p>
                        <p className="smallTxt">{LocaleStrings.delivered}</p>
                      </span>
                    </div>
                  </li>
                  <li
                    className={"emaillog-box " + openSelected}
                    onClick={() => this.sortByUserCategory("opened", "li")}
                    style={{
                      cursor: `${opencursorStyle}`,
                    }}
                  >
                    <div>
                      <span className="pull-right iconCircularRight">
                        <div className=""></div>
                      </span>
                      <span className="pull-left txtLeft txtLeftSupport">
                        <p className="bigNumbers">{opened.length}</p>
                        <p className="smallTxt">{LocaleStrings.opened}</p>
                      </span>
                    </div>
                  </li>
                  <li
                    className={"emaillog-box " + failedSelected}
                    onClick={() => this.sortByUserCategory("failed", "li")}
                    style={{
                      cursor: `${failedcursorStyle}`,
                    }}
                  >
                    <div>
                      <span className="pull-right iconCircularRight">
                        <div className=""></div>
                      </span>
                      <span className="pull-left txtLeft txtLeftSupport">
                        <p className="bigNumbers">{failed.length}</p>
                        <p className="smallTxt">{LocaleStrings.failed}</p>
                      </span>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="vertical-align-center-justify-between">
                <select
                  className="dropdown-height-border p-10"
                  onChange={(e) => this.sortByUserCategory(e, "select")}
                  value={sortByCategory}
                >
                  {categories.map((object, index) => {
                    return (
                      <option
                        key={`${object.value}-${index}`}
                        value={object.value}
                      >
                        {object.label}
                      </option>
                    );
                  })}
                </select>
                {emailLogData && emailLogData.count > 0 ? (
                  <div className="user-counting-per-page pl-30">
                    {LocaleStrings.email_log_counting_per_page.replace(
                      /startnum|endnum|totalnum/gi,
                      (matched) => mapObj[matched]
                    )}
                  </div>
                ) : (
                  ""
                )}
              </div>

              {emailLogData &&
              emailLogData.data &&
              emailLogData.data.length > 0 ? (
                <table className="table">
                  <thead>
                    <tr>
                      <th style={{ width: "20%" }}>
                        {LocaleStrings.th_receiver_EmailLog}
                      </th>
                      <th style={{ width: "10%" }}>
                        {LocaleStrings.th_datetime_EmailLog}
                      </th>
                      <th style={{ width: "10%" }}>
                        {LocaleStrings.th_logfrom_EmailLog}
                      </th>
                      {/* <th>{LocaleStrings.th_finalstatus_EmailLog}</th> */}
                      <th style={{ width: "45%" }}>
                        {LocaleStrings.th_statusfromlogs_EmailLog}
                      </th>
                      <th style={{ width: "15%" }}>
                        {LocaleStrings.th_content_EmailLog}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="tbody-background">
                    {this.renderList()}
                  </tbody>
                </table>
              ) : (
                <NoContent contentType={NO_EMAILLOGS} />
              )}
              {emailLogData && emailLogData.count > itemCount ? (
                <Pagination
                  activePage={pageNumber}
                  itemsCountPerPage={itemCount}
                  totalItemsCount={emailLogData.count}
                  pageRangeDisplayed={10}
                  onChange={this.paginationCallback}
                  style={{ float: "right" }}
                />
              ) : null}
            </>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    emailLogData: state.emailLogData,
    deviceSize: state.deviceSize,
    allEmailLog: state.allEmailLog,
  };
}
export default connect(mapStateToProps, {
  fetchEmailLog,
  searchEmailLogs,
  sortEmailLogByStatus,
  fetchAllEmailLog,
})(EmailLog);
